import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import { Grid, TextField } from '@mui/material'

const EmergencyVehicleAccess = () => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <TextField
        multiline
        minRows={2}
        label="Emergency Vehicle Access"
        fullWidth
        value={medPlan?.emergencyVehicleAccess}
        InputLabelProps={{
          shrink: !!medPlan?.emergencyVehicleAccess,
        }}
        onChange={(e) => {
          setMedPlan((prev) => ({
            ...prev,
            emergencyVehicleAccess: e.target.value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
      />
    </Grid>
  )
}

export default React.memo(EmergencyVehicleAccess)
